import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { auth } from '../lib/api';

export default function ForgotPassword() {
  const [email,   setEmail]   = useState('');
  const [sent,    setSent]    = useState(false);
  const [error,   setError]   = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await auth.forgotPassword(email);
      setSent(true);
    } catch (err) {
      setError(err.response?.data?.error || 'Something went wrong');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{
      minHeight: '100vh', display: 'flex', alignItems: 'center',
      justifyContent: 'center', background: 'var(--bg-deep)',
      backgroundImage: `radial-gradient(ellipse at 60% 20%, rgba(139,127,255,0.06) 0%, transparent 60%)`
    }}>
      <div style={{ width: '100%', maxWidth: 380, padding: '0 20px' }}>

        {/* Logo */}
        <div style={{ textAlign: 'center', marginBottom: 40 }}>
          <div style={{ fontFamily: 'var(--font-mono)', fontSize: 32, fontWeight: 700, color: 'var(--text-primary)' }}>
            Sig<span style={{ color: 'var(--accent-purple)' }}>nal</span>
          </div>
          <div style={{ fontSize: 11, color: 'var(--text-dim)', fontFamily: 'var(--font-mono)',
                        letterSpacing: '3px', textTransform: 'uppercase', marginTop: 8 }}>
            Social Intelligence Platform
          </div>
        </div>

        <div className="card">
          {sent ? (
            <div style={{ textAlign: 'center', padding: '8px 0' }}>
              <div style={{ fontSize: 32, marginBottom: 16 }}>📬</div>
              <div style={{ fontWeight: 600, color: 'var(--text-primary)', marginBottom: 8 }}>
                Check your inbox
              </div>
              <div style={{ fontSize: 13, color: 'var(--text-dim)', lineHeight: 1.6 }}>
                If that email has an account, we've sent a reset link. It expires in 1 hour.
              </div>
            </div>
          ) : (
            <>
              <h2 style={{ fontSize: 16, fontWeight: 600, marginBottom: 8, color: 'var(--text-primary)' }}>
                Reset Password
              </h2>
              <p style={{ fontSize: 13, color: 'var(--text-dim)', marginBottom: 24 }}>
                Enter your email and we'll send you a reset link.
              </p>

              <form onSubmit={handleSubmit}>
                <div style={{ marginBottom: 20 }}>
                  <label className="label">Email</label>
                  <input
                    type="email" required
                    value={email}
                    onChange={e => setEmail(e.target.value)}
                    placeholder="you@company.com"
                  />
                </div>

                {error && (
                  <div style={{ marginBottom: 16, padding: '10px 14px',
                                background: 'rgba(255,107,107,0.08)',
                                border: '1px solid rgba(255,107,107,0.2)',
                                borderRadius: 6, fontSize: 13, color: 'var(--accent-red)' }}>
                    {error}
                  </div>
                )}

                <button
                  type="submit" className="btn btn-primary"
                  style={{ width: '100%', justifyContent: 'center' }}
                  disabled={loading}
                >
                  {loading ? <span className="pulsing">SENDING...</span> : 'Send Reset Link →'}
                </button>
              </form>
            </>
          )}
        </div>

        <div style={{ textAlign: 'center', marginTop: 20, fontSize: 13, color: 'var(--text-dim)' }}>
          <Link to="/login" style={{ color: 'var(--accent-purple)' }}>← Back to Sign In</Link>
        </div>
      </div>
    </div>
  );
}
